export const ACCOUNT_KEY = "ACCOUNT_KEY";
export const USERS_ONLINE = "USERS_ONLINE";
export const PENDING_REQUESTS_KEY = "PENDING_REQUESTS_KEY";
export const OUT_GOING_REQUESTS_KEY = "OUT_GOING_REQUESTS_KEY";
export const ALL_FRIENDS_KEY = "ALL_FRIENDS_KEY";
export const BLOCKED_FRIENDS_KEY = "BLOCKED_FRIENDS_KEY";
export const OPEN_CHANNEL = "OPEN_CHANNEL";
export const OPEN_SERVER = "OPEN_SERVER";
export const CHANNEL_MESSAGES_KEY = (channelId) => `CHANNEL_MESSAGES_KEY-${channelId}`;
